import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Box } from '@material-ui/core';
import { getThemeColors } from '../utils/themeUtils';
import SchoolIcon from '@material-ui/icons/School';
import CodeIcon from '@material-ui/icons/Code';

const useStyles = makeStyles(theme => ({
	container: {
		backgroundColor: '#1e293b',
		borderRadius: '8px',
		border: '1px solid rgba(255, 255, 255, 0.1)',
		overflow: 'hidden',
		boxShadow: 'none',
		width: '100%',
		boxSizing: 'border-box'
	},
	gaugesGrid: {
		display: 'grid',
		gridTemplateColumns: '1fr',
		[theme.breakpoints.up('sm')]: {
			gridTemplateColumns: 'repeat(2, 1fr)',
			'& > div:first-child': {
				borderRight: '1px solid rgba(255, 255, 255, 0.1)'
			}
		}
	},
	gaugeCard: {
		padding: '24px',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		minWidth: 0,
		textAlign: 'center'
	},
	icon: {
		fontSize: 48,
		marginBottom: theme.spacing(2),
		opacity: 0.9
	},
	promoTitle: {
		fontSize: '18px',
		fontWeight: 700,
		color: '#f8fafc',
		marginBottom: theme.spacing(1),
		lineHeight: 1.3
	},
	promoText: {
		fontSize: '13px',
		color: '#94a3b8',
		lineHeight: 1.6,
		maxWidth: '220px'
	}
}));

const StudentMetricGauges = ({ courses = [], themeMode = 'dark' }) => {
	const classes = useStyles();
	const colors = getThemeColors(themeMode);

	const totalCourses = courses.length || 0;

	return (
		<div 
			className={classes.container}
			style={{
				backgroundColor: colors.card.background,
				border: `1px solid ${colors.card.border}`,
				boxShadow: colors.card.shadow
			}}
		>
			<div 
				className={classes.gaugesGrid}
				style={{
					'& > div:first-child': { borderColor: colors.border.primary }
				}}
			>
				{/* Left: Course Promo */}
				<div className={classes.gaugeCard}>
					<SchoolIcon 
						className={classes.icon}
						style={{ color: colors.accent.blue }}
					/>
					<Typography className={classes.promoTitle}>
						{totalCourses}+ Courses Available
					</Typography>
					<Typography className={classes.promoText} style={{ color: colors.text.muted }}>
						Access cutting-edge computer science courses designed for hands-on learning with real HPC resources
					</Typography>
				</div>

				{/* Right: Application Promo */}
				<div className={classes.gaugeCard}>
					<CodeIcon 
						className={classes.icon}
						style={{ color: colors.accent.green }}
					/>
					<Typography className={classes.promoTitle}>
						Professional Tools
					</Typography>
					<Typography className={classes.promoText} style={{ color: colors.text.muted }}>
						Experiment with industry-standard platforms like E4S, WatsonX, and AI frameworks used by leading researchers
					</Typography>
				</div>
			</div>
		</div>
	);
};

export default React.memo(StudentMetricGauges, (prevProps, nextProps) => {
	return prevProps.themeMode === nextProps.themeMode &&
		prevProps.courses.length === nextProps.courses.length;
});
